<ngx-smart-modal #myModal1 identifier="myModal1">
  <h2 class="modalError">Please login and subscribe to access this content.</h2>
  <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
</ngx-smart-modal>
 <!-- <ngx-smart-modal #myModal2 identifier="myModal2">
   <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
   <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
 </ngx-smart-modal> --><div class="loadingBox" *ngIf="!loaded">
  <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
 </div>
 <div *ngIf="loaded"><app-header *ngIf="loggedIn" ></app-header>
<div id="wrapper">
<app-sidebar *ngIf="loggedIn"></app-sidebar>
<div id="content-wrapper">
         <div class="container-fluid pb-0 pt-0"> <div class="spacerBlock"></div>
         <div class="row">
          <div class="col-md-9">
<span class="termsConditionsText" [innerHTML]="termsHTML"></span>
<div style="height: 200px;">
  <button *ngIf="!loggedIn && !isMondia" routerLink="/login" type="button" class="form-control">
    <span i18n="@@Login | Login Button">Login</span>
  </button>
  <button *ngIf="!loggedIn && isMondia" (click)='goSubReg();'  type="button" class="form-control">
    <span i18n="@@Login | Login Button">Login Now</span>
  </button>
</div>
</div>
</div>
      </div>
      <div *ngIf="loggedIn" class="container-slider">
        <div class="navbarbottom">
          <a routerLink="/"><i _ngcontent-c3="" class="fas fa-fw fa-home"></i> <span class="homeFooterLink" i18n="@@Footer Home Link">Home</span></a>
          <a routerLink="/my-list"><i _ngcontent-c3="" class="fas fa-fw fa-list"></i> <span class="myListFooterLink" i18n="@@Footer My List Link">My List</span></a>
 
        </div>
        </div>
      </div>
    </div>
    </div>
 
  